export default "__VITE_ASSET__CHIKxHnb__"